<div class="regionCard regionCard--fixed cursor-pointer" *ngIf="region">
  <p-card>
    <ng-template pTemplate="header">
      <div
        class="headCard flex justify-content-between"
        [style.backgroundImage]="
          'url(' +
          (region?.headerImg?.src ||
            'https://res.cloudinary.com/divinea/image/upload/v1/production/cache/lgdkpct7hn0skbfbupgi.jpg') +
          ')'
        "
      ></div>
    </ng-template>

    <div class="region-card__lower">
      <h3 class="region-title text-ellipsis-2" [title]="region?.name">{{ region?.name }}</h3>
      <p class="region-discover text-sm text-color-secondary m-0">{{ region?.discoverText }}</p>
      <p class="region-desc text-ellipsis-2 m-0">{{ region?.short_description }}</p>
      <div class="region-footer winery flex justify-content-between align-items-center">
        <span class="text-sm nameCity">
          <i class="pi pi-map-marker" style="font-size: 0.9rem"></i>
          {{ region?.numExperiences }}+ esperienze
        </span>
      </div>
    </div>
  </p-card>
</div>
